'use client'

/***
 *
 * @file components/EventContainer/index.tsx
 * @description EventContainer component will be used for rendering the content.
 * @author Ayesha Kumar
 * @organization Truminds Software System
 * @since 3 Jul 2026
 *
 */

// import "./EventContainer.scss";
import classNames from 'classnames'
import { ReactNode, useEffect, useRef, useState, } from 'react';

interface EventContainerProps {
  /** children components to be rendered within the Container layout */
  children?: ReactNode | never,
  hideEvent?: string | null,
  showEvent?: string | null
}


const EventContainer = ({ children, hideEvent = null, showEvent = null, ...props }: EventContainerProps) => {

  const isInContentfulStudio = (typeof window !== "undefined") && window.self !== window.top && window?.document?.getElementsByClassName("styles-module_tooltipWrapper__kqvmR")?.length > 0;
  const [show, setShow] = useState(true);
  const containerRef = useRef<HTMLDivElement | null>(null)

  const hideContainer = (e: Event) => {
    setShow(false);
  }

  const showContainer = (e: Event) => {
    setShow(true);
  }


  useEffect(() => {
    if (showEvent) {
      window?.addEventListener(showEvent, showContainer)
    }
    if (hideEvent) {
      window?.addEventListener(hideEvent, hideContainer);
    }

    return () => {
      if (showEvent) {
        window?.removeEventListener(showEvent, showContainer)
      }
      if (hideEvent) {
        window?.removeEventListener(hideEvent, hideContainer);
      }
    }
  })

  return (
    <div data-testid="EventContainer"
      className={classNames(
        "EventContainer-container",
      )} ref={containerRef}>
      {(isInContentfulStudio ? true : show) ? children : null}
    </div>
  );
};

export default EventContainer;
